import { useContext } from 'react';
import SubscriptionsContext from '../contexts/SubscriptionsContext';

export const usePuntosColombiaAccruals = () => {
  const {
    puntosColombiaAccruals,
    puntosColombiaAccrualsLoading,
    retryPuntosColombiaAccrual,
    isRetryingPuntosColombiaAccrual,
    refetchPuntosColombiaAccruals,
  } = useContext(SubscriptionsContext);

  return {
    accruals: puntosColombiaAccruals,
    isLoading: puntosColombiaAccrualsLoading,
    retry: retryPuntosColombiaAccrual,
    isRetrying: isRetryingPuntosColombiaAccrual,
    refetch: refetchPuntosColombiaAccruals,
  };
};
